import SettingsIcon from '@material-ui/icons/Settings';
import React, { DOMAttributes, PropsWithChildren } from 'react';
import { ExpandableMenu } from './ExpandableMenu';
import { SubMenuItem } from './SubMenuItem';
import { LanguageMenuItems, ILanguageMenuProps } from './LanguageMenuItems';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    icon: {
        color: (theme.settingsMenu && theme.settingsMenu.iconColor) || theme.palette.common.white
    },
    button: {
        display: (theme.settingsMenu && theme.settingsMenu.display) || undefined
    }
}));

export const SettingsMenu = (props: PropsWithChildren<ISettingsMenuProps & Pick<DOMAttributes<HTMLElement>, 'onClick'>>): JSX.Element => {
    const menuItems = [
        <SubMenuItem key="language" label={props.languageLabel}>
            <LanguageMenuItems {...props} />
        </SubMenuItem>
    ];
    const classes = useStyles();

    return (
        <ExpandableMenu name="settings" icon={SettingsIcon} classes={classes}>
            {menuItems}
            {props.children}
        </ExpandableMenu>
    );
};

export interface IOwnProps {
    languageLabel: string;
}

export type ISettingsMenuProps = IOwnProps & ILanguageMenuProps;
